// src/pages/PaedsPrescribingPro.js
import React from "react";

function PaedsPrescribingPro() {
  return (
    <div style={styles.container}>
      <h1>Paeds Prescribing Pro</h1>
      {/* Example iFrame or direct app embed */}
      <iframe
        src="https://www.paedspro.com"
        title="Paeds Prescribing Pro"
        style={styles.iframe}
      />
    </div>
  );
}

const styles = {
  container: {
    padding: "2rem",
  },
  iframe: {
    width: "100%",
    height: "800px",
    border: "none",
  },
};

export default PaedsPrescribingPro;